import React from 'react';

import { useAsyncFn } from 'react-use';

import { LbModal } from '../../../../shared/components/modals';
import { LbCheckbox, PasswordInput } from '../../../../shared/components/form-components';
import { useCustomerChangePasswordForm } from './hooks/useCustomerChangePasswordForm';
import classes from './CustomerChangePasswordModal.module.scss';

type CustomerChangePasswordModalProps = {
  userId: number;
  onClose: () => void;
};

const CustomerChangePasswordModal = ({
  userId,
  onClose,
}: CustomerChangePasswordModalProps) => {
  const { control, handlerPasswordChange, validateConfirmPassword } =
    useCustomerChangePasswordForm({ userId, onSuccessChange: onClose });

  const [status, handleFormSubmit] = useAsyncFn(handlerPasswordChange);

  const generalInputProps = { control, size: 'small', variant: 'outlined' } as const;

  return (
    <LbModal
      open
      title="Change Password"
      text="Enter at least 12 characters, including at least one uppercase letter, one lowercase letter, one number, and one special character (such as @, #, $, %, !, *)."
      primaryBtnConfig={{ text: 'Confirm', onClick: handleFormSubmit }}
      secondaryBtnConfig={{ text: 'Cancel', onClick: onClose }}
      isLoading={status.loading}
    >
      <form noValidate className={classes.formBox}>
        <PasswordInput
          {...generalInputProps}
          label="New Password"
          name="password"
          rules={{ required: 'Password is required' }}
        />
        <PasswordInput
          {...generalInputProps}
          label="Confirm New Password"
          name="repeatPassword"
          rules={{
            required: 'Confirm password is required',
            validate: validateConfirmPassword,
          }}
          omitValidation
        />
        <LbCheckbox
          control={control}
          name="sendViaEmail"
          label="Send the password via email"
          color="primary"
        />
      </form>
    </LbModal>
  );
};

export { CustomerChangePasswordModal };
